import { defaultTheme } from 'gd-design-library';

export const snackbar = {
  ...defaultTheme.snackbar,
  snackbar: {
    ...defaultTheme.snackbar.snackbar,
    default: {
      ...defaultTheme.snackbar.snackbar.default,
      position: 'fixed',
      bottom: '16px',
      left: '16px',
      zIndex: 1000,
      width: 'auto',
      maxWidth: '400px',
      flexDirection: 'row-reverse'
    }
  },
  snackbarContent: {
    ...defaultTheme.snackbar.snackbarContent,
    gap: '0',
    marginTop: '2px'
  },
  closeButton: {
    ...defaultTheme.snackbar.closeButton,
    position: 'static'
  }
};
